import { z } from 'zod';
import IBAN from 'iban';
import { zodUploadedFileMetadataSchema } from '../../../types/forms';

/**
 * NB!
 * If you need to change the schema, please also update the backend repository as it uses the same schema.
 * Otherwise the backend will reject the requests.
 */

const contactInfoSchema = z.object({
  name: z.string().min(1),
  address: z.string().min(1),
  zip: z.string().min(1),
  city: z.string().min(1),
  phone: z.string().min(1),
  email: z.string().email(),
  iban: z.string().refine(IBAN.isValid),
});

const eventSchema = z.object({
  name: z.string().min(1),
  date: z.string().date(),
  additionalInformation: z.string().optional(),
});

const purchaseReportSchema = z.object({
  report: z.string().min(1),
  amount: z.number().min(0.01),
  receipts: z.union([z.custom<FileList>(), z.array(zodUploadedFileMetadataSchema), z.undefined()]),
});

export const schema = z.object({
  contactInfo: contactInfoSchema,
  event: eventSchema,
  purchaseReports: z.array(purchaseReportSchema).min(1),
});

export type GeneralExpenseReportFormState = z.infer<typeof schema>;
